// extracted by mini-css-extract-plugin
var _1 = "UserMenuThemeMode-modulelist__Kjmwb List-moduleList__p8DRk";
export { _1 as "list" }
